import React from 'react';
import PropTypes from 'prop-types';
import Text from '../text';
import { SIZES, APPEARANCES, TYPES, TARGETS } from './constants';

const Link = ({
  href,
  target = TARGETS.blank,
  isUnderlined = false,
  size = SIZES.inherit,
  appearance = APPEARANCES.inherit,
  children,
  onClick = Function.prototype,
}) => {
  const linkConfig = {
    href,
    ...(target !== TARGETS.self && { target }),
  };

  return (
    <Text
      type={TYPES.link}
      linkConfig={linkConfig}
      isUnderlined={isUnderlined}
      size={size}
      appearance={appearance}
      onClick={onClick}
    >
      {children}
    </Text>
  );
};

export default Link;

Link.propTypes = {
  href: PropTypes.string.isRequired,
  target: PropTypes.oneOf(Object.values(TARGETS)),
  isUnderlined: PropTypes.bool,
  size: PropTypes.oneOf(Object.values(SIZES)),
  appearance: PropTypes.oneOf(Object.values(APPEARANCES)),
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  onClick: PropTypes.func,
};
